import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import { InvoicePage } from '~/modules/billing/components/InvoicePage/components/InvoicePage';

export const Invoice = (): JSX.Element => {
  const { t } = useTranslation('settings');

  return (
    <>
      <Helmet>
        <title>{t('account.billing.invoices.header')} - Shippo</title>
      </Helmet>
      <InvoicePage />
    </>
  );
};
